import React from "react";
import CountUp from "react-countup";

const Tentangkami = () => {
  return (
    <>
      <div className="font-inter">
        {/* Header / Hero Section */}
        <header className="relative w-full h-screen overflow-hidden">
          {/* Background Image */}
          <img
            src="/images/asset/new-hero-dapen.svg"
            alt="Hero"
            className="
        absolute inset-0 
        w-full h-full 
        object-cover        
        pointer-events-none select-none
      "
            style={{
              objectPosition: "center",
            }}
          />

          {/* Konten Teks */}
          <div className="relative z-20 flex flex-col items-center justify-center h-full text-center text-white px-4 -translate-y-32">
            <h1 className="flex flex-wrap items-center justify-center gap-2 text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug">
              <span className="bg-white text-red-600 px-3 py-1 rounded font-pontano">
                Layanan Dana Pensiun Untuk
              </span>
            </h1>
            <h1 className="flex flex-wrap items-center justify-center gap-2 text-3xl sm:text-4xl md:text-5xl font-semibold leading-snug mt-3">
              <span className="bg-white text-red-600 px-3 py-1 rounded font-pontano">
                Karyawan Toyota Astra
              </span>
            </h1>
            <a
              href="https://forms.gle/tLWGETDt5xrqryNg8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-6 bg-[#EF1C22] hover:bg-red-700 transition px-6 py-2 rounded-md text-sm font-medium shadow-lg"
            >
              Pengkinian Data Peserta
            </a>
          </div>

          {/* Gambar People */}
          {/* <div className="absolute bottom-0 left-1/2 -translate-x-1/2 z-10 w-[85%] sm:w-[70%] md:w-[62%] lg:w-[55%] xl:w-[45%]">
  <img
    src="/images/asset/group-tentang-kami.svg"
    alt="People"
    className="w-full h-auto object-contain"
  />
</div> */}
        </header>

        {/* Section setelah header dengan lengkungan */}
        <section className="relative z-20 bg-white rounded-t-[40px] -mt-12 sm:-mt-16 shadow-md px-4 sm:px-8 lg:px-24 py-8 sm:py-12">
          {/* Judul */}
          <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-gray-800 text-center font-pontano">
            Struktur Organisasi Dana Pensiun Toyota Astra <br />
            <span className="text-lg">(31 Desember 2024)</span>
          </h2>
          <div className="w-full flex justify-center px-4">
            <img
              src="/images/asset/pengurus-dapen.svg"
              alt="People"
              className="w-full max-w-2xl h-auto object-contain"
            />
          </div>
        </section>

        <section className="relative bg-gradient-to-b from-[#1A3E99] to-[#082B89] text-white py-10 px-4 sm:px-8 lg:px-24">
          {/* Judul */}
          <h2 className="text-2xl sm:text-3xl font-semibold text-center mb-10 font-pontano">
            Visi dan Misi
          </h2>

          {/* Card besar */}
          <div className="relative bg-white/5 backdrop-blur-sm rounded-t-lg px-6 py-10 md:px-10 md:py-12 border-x border-t border-white/30">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Visi */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <img
                    src="/images/asset/visi-misi.svg"
                    alt="Visi Icon"
                    className="w-8 h-5"
                  />
                  <h3 className="text-lg font-semibold font-pontano">
                    Visi Dana Pensiun Toyota Astra
                  </h3>
                </div>
                <p className="text-sm leading-relaxed text-white/90">
                  Menjadi Dana Pensiun yang sehat untuk menunjang kepentingan
                  Pendiri dan Mitra Pendiri serta Kesinambungan Penghasilan
                  Peserta.
                </p>
              </div>

              {/* Misi */}
              <div>
                <div className="flex items-center gap-2 mb-2">
                  <img
                    src="/images/asset/visi-misi.svg"
                    alt="Misi Icon"
                    className="w-8 h-5"
                  />
                  <h3 className="text-lg font-semibold font-pontano">
                    Misi Dana Pensiun Toyota Astra
                  </h3>
                </div>
                <ul className="list-disc list-inside space-y-2 text-sm text-white/90">
                  <li>
                    Mengelola Aset Dana Pensiun sesuai dengan arahan investasi
                  </li>
                  <li>
                    Menyelenggarakan dana Pensiun yang transparan, akuntabel,
                    dan bertanggung jawab untuk semua stakeholder
                  </li>
                  <li>
                    Memberikan pelayanan terbaik kepada Pendiri, Mitra Pendiri,
                    dan Peserta
                  </li>
                </ul>
              </div>
            </div>

            {/* Fade gradient bawah */}
            <div className="absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-b from-transparent to-[#082B89] rounded-b-lg"></div>
          </div>
        </section>

        <section className="py-12 px-4 sm:px-8 bg-white text-center">
          <h2 className="text-xl sm:text-2xl font-semibold mb-10 font-pontano">
            Kepesertaan per 30 April 2025
          </h2>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 max-w-4xl mx-auto">
            {/* TMMIN */}
            <div className="flex flex-col items-center">
              <div className="bg-[#EF1C22] text-white px-8 py-2 font-medium w-full text-center font-pontano">
                TMMIN
              </div>
              <div className="flex gap-8 mt-4">
                <div className="text-center">
                  <div className="text-2xl font-bold font-pontano">
                    <CountUp end={2411} duration={2} separator="." />
                  </div>
                  <div className="text-sm mt-1">Peserta Aktif</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-[#EF1C22] font-pontano">
                    <CountUp end={346} duration={2} separator="." />
                  </div>
                  <div className="text-sm text-[#EF1C22] mt-1">
                    Peserta Pasif
                  </div>
                </div>
              </div>
            </div>

            {/* TAM */}
            <div className="flex flex-col items-center">
              <div className="bg-[#0C288F] text-white px-8 py-2 font-medium w-full text-center font-pontano">
                TAM
              </div>
              <div className="flex gap-8 mt-4">
                <div className="text-center">
                  <div className="text-2xl font-bold font-pontano">
                    <CountUp end={403} duration={2} separator="." />
                  </div>
                  <div className="text-sm mt-1">Peserta Aktif</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-[#EF1C22] font-pontano">
                    <CountUp end={7} duration={2} separator="." />
                  </div>
                  <div className="text-sm text-[#EF1C22] mt-1">
                    Peserta Pasif
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Tentangkami;
